import React, { useEffect, useState } from "react";
import { Box, Dialog, DialogContent, Grid, Pagination, Stack, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, } from "@mui/material";
import { Avatar, AvatarGroup } from "@mui/joy";
import { dashboardIcon, taskAssign } from "../../config/images";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { getFarmerListForReport, getReportDetails, sendReminder, } from "../../config/services";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import translations from "../../config/language";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

function clampAvatars(avatars, maxVisible = 3) {
  const totalAvatars = avatars.length;
  const visibleAvatars = avatars.slice(0, maxVisible); // Show only 3
  const surplus = totalAvatars > maxVisible ? totalAvatars - maxVisible : 0; // Extra count

  return { avatars: visibleAvatars, surplus };
}
const ReportDetailView = ({ galleryIsOpen, setGalleryIsOpen }) => {
  const handleBackClick = () => {
    const currentPage =
      new URLSearchParams(window.location.search).get("page") || 1;
    navigate(`/report-submission?page=${currentPage}`);
  };
  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Report Submission" && module.is_editor === true
  ) ? true : false;
  const navigate = useNavigate();
  const params = useParams();

  const [reminderModal, setReminderModal] = useState(false);
  const [reports, setReports] = useState([]);

  const language = process.env.REACT_APP_LANGUAGE;

  const [reportDetails, setReportDetails] = useState([]);
  useEffect(() => {
    if (reportDetails) {
      setReports([
        {
          title: translations[language].taskTitle,
          desc: reportDetails?.assigned_task_title,
        },
        {
          title: "Data Collector",
          desc: reportDetails?.data_collector_name,
        },
        {
          title: "Date",
          desc: dayjs(reportDetails.created_at).format("DD/MM/YYYY"),
        },
        {
          title: "Farmers Registered",
          desc: reportDetails?.number_of_farmers,
        },
        {
          title: "Summary",
          desc: reportDetails.summary,
        },
        {
          title: "Attachment",
          desc: reportDetails?.attachment,
        },
      ]);
    }
  }, [reportDetails]);

  const [images, setImages] = useState([]);
  const [imageIndex, setImageIndex] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [farmersDetails, setFarmersDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState();
  const [perPage, setPerPage] = useState(10);
  const [reminderData, setReminderData] = useState({
    taskTitle: "",
    taskDescription: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setReminderData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    if (!reminderData.taskTitle) {
      notifyError(translations[language].pleaseEnterTaskTitle);
      return true;
    }
    if (!reminderData.taskDescription) {
      notifyError(translations[language].pleaseEnterTaskDescription);
      return true;
    }
    const params = {
      assign_task_id: reportDetails.assigned_task,
      title: reminderData.taskTitle,
      description: reminderData.taskDescription,
    };
    try {
      setIsLoading(true);
      const resp = await sendReminder(params);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setReminderModal(false);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      setReminderModal(false);
    }
  };

  const fetchData = async () => {
    try {
      const resp = await getReportDetails(params.id);
      if (resp.status == 200) {
        setReportDetails(resp.data);
      }
    } catch (error) {
      setReportDetails([]);
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleGalleryOpen = (items, index) => {
    setGalleryIsOpen(true);
    setImages(items);
    setImageIndex(index);
  };

  const fetchFarmersList = async () => {
    const data = {
      report_id: params.id,
    };
    try {
      const resp = await getFarmerListForReport(data, currentPage, perPage);
      if (resp.data.results.success == true) {
        setFarmersDetails(resp.data.results.payload);
        setCount(resp.data.count);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchFarmersList();
  }, [currentPage, perPage]);

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleVisibilityClick = (id) => {
    navigate(`/farmer/farmer-detail/${id}?page=${currentPage}`, {
      state: { from: "Report submission" }
    });
  };
  return (
    <>
      <Box className="task-detail-box">
        <Box
          className="d-flex justify-content-between align-items-center"
          style={{ flexWrap: "wrap" }}
        >
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => handleBackClick()}
            />
            <img
              src={taskAssign.taskDetail}
              alt=""
            />
            <Typography variant="h6" gutterBottom>
              {translations[language].taskReportDetailsView}
            </Typography>
          </Box>
          <Box
            className="d-flex align-items-center"
            style={{ flexWrap: "wrap" }}
          >
            <Typography variant="h6" gutterBottom>
              {translations[language].status}: <b>{reportDetails?.farmer_count}/{reportDetails?.no_of_farmers}</b>
            </Typography>
            <button
              className="assign-task-btn"
              style={{ height: "46px" }}
              onClick={() =>{
                if (!isAccess) {
                  notifyError(translations[language].youDontHaveAccess);
                  return true;
                }
                setReminderModal(true)}
              }
            >
              {translations[language].sendReminder}
            </button>
          </Box>
        </Box>
        <Box className="pt-3">
          <Typography
            variant="body1"
            gutterBottom
            style={{ marginLeft: "20px", color: "#3C4856" }}
          >
            <b>{reportDetails?.data_collector_name}</b>
          </Typography>
          <Grid container className="task-detail-table">
            {reports.map((task, index) => (
              <React.Fragment key={index}>
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md={4}
                  lg={4}
                  className="grid-item"
                  style={{
                    borderTop: index === 0 ? "1px solid #D9D9D9" : "",
                    paddingLeft: "25px",
                  }}
                >
                  {task.title}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={8}
                  md={8}
                  lg={8}
                  className="grid-item"
                  style={{ borderTop: index === 0 ? "1px solid #D9D9D9" : "" }}
                >
                  {task.title === "Attachment" ? (
                    <AvatarGroup sx={{ "--AvatarGroup-gap": "-16px" }}>
                      {(() => {
                        const { avatars, surplus } = clampAvatars(
                          (task?.desc || []).map(photo => photo.files) || [],
                          3
                        );
                        return (
                          <>
                            {avatars.map((photo, index) => (
                              <Avatar
                                key={index}
                                className="cursor-pointer"
                                sx={{ width: 35, height: 35 }}
                                onClick={() => handleGalleryOpen((task?.desc || []).map(photo => photo.files), index)}
                              >
                                <img
                                  src={photo || "/placeholder.svg"}
                                  alt={`Attachment ${index + 1}`}
                                  style={{
                                    width: 35,
                                    height: 35,
                                    objectFit: "cover",
                                  }}
                                />
                              </Avatar>
                            ))}
                            {surplus > 0 && (
                              <Avatar
                                sx={{
                                  width: 35,
                                  height: 35,
                                  backgroundColor: "#3C4856",
                                  color: "#FFFFFF",
                                  fontSize: 14,
                                  fontWeight: 400,
                                  cursor: "pointer",
                                }}
                                onClick={() => handleGalleryOpen((task?.desc || []).map(photo => photo.files), 3)}
                              >
                                +{surplus}
                              </Avatar>
                            )}
                          </>
                        );
                      })()}
                    </AvatarGroup>

                  ) : (
                    <b>{task.desc}</b>
                  )}
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Box>
        {farmersDetails?.length > 0 &&

          <Box className="pt-5">
            <Typography
              variant="body1"
              gutterBottom
              style={{ marginLeft: "20px", color: "#3C4856" }}
            >
              <b>{translations[language].farmersList}</b>
            </Typography>
            <Box style={{ minHeight: "max-content", maxHeight: "50vh", width: "100%", overflowX: "auto" }}>
              <Table className="task-assign-table farmer-table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ textAlign: "center" }}>{translations[language].srNo}</TableCell>
                    <TableCell>{translations[language].photo}</TableCell>
                    <TableCell>{translations[language].farmerName}</TableCell>
                    <TableCell>{translations[language].date}</TableCell>
                    <TableCell>{translations[language].dataCollectorName}</TableCell>
                    <TableCell>{translations[language].mobileNo}</TableCell>
                    <TableCell>{translations[language].location}</TableCell>
                    <TableCell>{translations[language].statusView}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {farmersDetails?.map((farmer, index) => (
                    <TableRow key={farmer.id}>
                      <TableCell style={{ textAlign: "center" }}>{index + 1 + (currentPage - 1) * perPage}</TableCell>
                      <TableCell>
                        {farmer.farmer_photo ? <img
                          src={farmer.farmer_photo}
                          alt=""
                          className="farmer-photo"
                        /> : <img
                          src={dashboardIcon.profileImage}
                          alt=""
                          className="farmer-photo"
                        />}

                      </TableCell>
                      <TableCell>{farmer.first_name} {farmer.middle_name} {farmer.last_name}</TableCell>
                      <TableCell>{dayjs(farmer.created_at).format("YYYY/MM/DD")}f</TableCell>
                      <TableCell>{farmer.data_collector_name}</TableCell>
                      <TableCell>{farmer.mobile_number}</TableCell>
                      <TableCell>{farmer.farmer_house_address}</TableCell>
                      <TableCell>
                        <div className="d-flex gap-4">
                          <div style={{ width: "50px", color: farmer.status == "10" ? "#31A05F" : "" }}
                          >
                            {farmer.status == 9 ?
                              translations[language].pending
                              : farmer.status == 10 ?
                                translations[language].approved
                                : translations[language].reject}
                          </div>
                          <VisibilityIcon
                            onClick={() => handleVisibilityClick(farmer.id)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
            <Box
              display="flex"
              justifyContent="end"
              alignItems="center"
              className="pagination"
            >
              <Stack spacing={2} className="mb-3">
                <CustomPagination
                  count={Math.ceil(count / perPage)}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Stack>
            </Box>
          </Box>
        }

        <Dialog
          open={reminderModal}
          onClose={() => setReminderModal(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5
                className="p-3 mb-0"
                style={{ textAlign: "center", marginLeft: "100px" }}
              >
                {translations[language].sendReminder}
              </h5>
              <img
                src={taskAssign.closeIcon}
                alt=""
                style={{
                  height: "30px",
                  width: "30px",
                  cursor: "pointer",
                  marginLeft: "85px",
                }}
                onClick={() => setReminderModal(false)}
              />
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label={translations[language].enterReminderTitle}
                name="taskTitle"
                value={reminderData.taskTitle}
                onChange={(e) => handleChange(e)}
                className="mb-3"
              />
              <TextField
                fullWidth
                id="outlined-multiline-static"
                label={translations[language].description}
                name="taskDescription"
                multiline
                value={reminderData.taskDescription}
                onChange={handleChange}
                className="textarea-taskDescription mb-3"
                rows={3}
              />

              <button className="assign-task-button" onClick={handleSubmit}>
                {translations[language].sendReminder}
              </button>
            </form>
          </DialogContent>
        </Dialog>

        {galleryIsOpen && (
          <ImageGallery
            images={images}
            isOpen={galleryIsOpen}
            onClose={() => setGalleryIsOpen(false)}
            imageIndex={imageIndex}
          />
        )}
      </Box>
    </>
  );
};
export default ReportDetailView;
